let state = {
    allarquivos:[],
    allvideos:[],
    allslides:[],
    allaudios:[],
    allquestionarios:[],
    allextras:[],
    extrasMateria:[],
    allArquivosTipo:[],
    allArquivosDisciplina:[],
    allArquivosVideos:'',
    allArquivosSlides:'',
    allArquivosExtras:'',
    allArquivosAudios:'',
    link_arquivo:'',
    
}

export default state